const artisans = [
  {
    id: 1,
    name: "Jean Dupont",
    job: "Plombier",
    city: "Lyon",
    rating: 4,
    category: "Bâtiment"
  },
  {
    id: 2,
    name: "Marc Lefevre",
    job: "Électricien",
    city: "Villeurbanne",
    rating: 5,
    category: "Services"
  },
  {
    id: 3,
    name: "Thomas Blanc",
    job: "Menuisier",
    city: "Saint-Étienne",
    rating: 3,
    category: "Fabrication"
  },
  {
    id: 4,
    name: "Lucas Moreau",
    job: "Boulanger",
    city: "Lyon",
    rating: 4,
    category: "Alimentation"
  },
  {
    id: 5,
    name: "Antoine Petit",
    job: "Peintre",
    city: "Annecy",
    rating: 4,
    category: "Bâtiment"
  },
  {
    id: 6,
    name: "Julien Roux",
    job: "Carreleur",
    city: "Valence",
    rating: 3,
    category: "Bâtiment"
  }
  
];

export default artisans;